
module.config(function($stateProvider) {

    $stateProvider.state('program.info.representation', {
        url: '/representation', 
        templateUrl: 'programs/info/representation',
        controllerAs: '$ctrl',
        resolve: {
            representation: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'representation');
            } 
        },

        controller: function($scope, representation) {
            var $ctrl = this;
            $scope.representation = representation;

            $ctrl.senators = [];
            $ctrl.other = [];
            $ctrl.governor = [];
            $ctrl.houseRep = [];

            angular.forEach(representation.offices, function(office) {
                var division = representation.divisions[office.divisionId];
                angular.forEach(office.officialIndices, function(officialIndex) {
                    var official = representation.officials[officialIndex];
                    var data = {
                        division: division,
                        office: office,
                        official: official,
                    };

                    if (isPOTUS(data) || isVPOTUS(data)) {
                        return;
                    }
                    else if (isSenator(data)) {
                        $ctrl.senators.push(data);
                    }
                    else if (isRepresentative(data)) {
                        $ctrl.houseRep.push(data);
                    }
                    else if (isGovernor(data)) {
                        $ctrl.governor.push(data);
                    }
                    else {
                        $ctrl.other.push(data);
                    }
                });
            });

            $ctrl.accordions = [
                {items: $ctrl.senators, showOffice: false},
                {items: $ctrl.houseRep, showOffice: false},
                {items: $ctrl.governor, showOffice: false},
                {items: $ctrl.other, label: 'Local Representatives', showOffice: true},
            ];
        }
    })

});


module.component("repAccordion", {
    templateUrl: 'programs/info/representation/accordion',
    bindings: {
        label: "<",
        representatives: '<',
        startExpanded: "<",
        showOfficeName: "<",
    },
    controller: function() {
    },
});

module.component("repChannelLink", {
    templateUrl: 'programs/info/representation/channelLink',
    bindings: { channel: '<', showId: '<' },
    controller: function() { },
});

module.component("repOfficialRow", {
    templateUrl: 'programs/info/representation/officialRow',
    bindings: {
        official: '<',
        office: '<',
        expanded: '<',
        showOfficeName: "<",
    },

    controller: function() {

        this.details = [
            {items: this.official.urls, label: 'Web Addresses', type: "link"},
            {items: this.official.phones, label: 'Phone Numbers'},
            {items: this.official.address, label: 'Addresses', type: "address"},
            {items: this.official.channels, label: 'Social Media', type: "channel"},
        ];

        this.toggle = angular.bind(this, function() {
            this.expanded = !this.expanded;
        });
    },
});

module.component("repDetailRow", {
    templateUrl: 'programs/info/representation/detailRow',
    bindings: {
        items: "<",
        label: "<",
        type: '<',
    },
    controller: function() {
    },
});


module.filter("repChannelUrl", function() {

    return function(channel) {
        
        if (!channel) { return "" }

        switch(channel.type) {
            case 'Facebook':
                return "https://www.facebook.com/" + channel.id;
            case 'Twitter':
                return 'https://www.twitter.com/' + channel.id;
            case 'YouTube':
                return "https://www.youtube.com/user/" + channel.id;
            case 'GooglePlus':
                return "https://plus.google.com/" + channel.id;
        }
    }
});


module.filter("repChannelIcon", function() {

    return function(channel) {
    
        if (!channel) { return "" }

        switch(channel.type) {
            case 'Facebook':
                return "fa-facebook";
            case 'Twitter':
                return "fa-twitter";
            case 'YouTube':
                return "fa-youtube";
            case 'GooglePlus':
                return "fa-google-plus";
        }
    }
});


module.filter("repParty", function() {
    return function(party) {
        switch (party) {
            case 'Republican':
            case 'Democratic':
            case 'Independent':
                return "(" + party[0] + ")";
            default:
                return ""
        }
    }
});

function hasRoleAtLevel(data, level, role) {
    return data.office.levels
        && data.office.roles
        && data.office.levels[0] === level
        && data.office.roles[0] === role;
}

function isPOTUS(data) {
    return hasRoleAtLevel(data, "country", "headOfState");
}

function isVPOTUS(data) {
    return hasRoleAtLevel(data, "country", "deputyHeadOfGovernment");
}

function isSenator(data) {
    return hasRoleAtLevel(data, "country", "legislatorUpperBody");
}

function isRepresentative(data) {
    return hasRoleAtLevel(data, "country", "legislatorLowerBody");
}

function isGovernor(data) {
    return hasRoleAtLevel(data, "administrativeArea1", "headOfGovernment")
}
